import Floor from "./Floor_v2.jsx";

export default Floor;
